import React, { ErrorInfo, ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-[#0a0a0c] text-slate-900 dark:text-white p-4 text-center">
          <div className="bg-red-50 dark:bg-red-900/10 p-6 rounded-full mb-6 animate-bounce">
            <AlertTriangle size={48} className="text-red-500" />
          </div>
          <h1 className="text-3xl font-black mb-4">Bir şeyler ters gitti.</h1>
          <p className="text-gray-500 dark:text-gray-400 max-w-md mb-8">
            Uygulama beklenmeyen bir hatayla karşılaştı. Lütfen sayfayı yenilemeyi deneyin.
          </p>
          <div className="bg-gray-100 dark:bg-black/30 p-4 rounded-lg text-left w-full max-w-lg mb-8 overflow-auto max-h-40 border border-gray-200 dark:border-white/10">
            <code className="text-xs text-red-500 font-mono">
              {this.state.error?.toString()}
            </code>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg hover:shadow-primary/25 active:scale-95"
          >
            <RefreshCw size={20} /> Sayfayı Yenile
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}